import { Building2 } from "lucide-react";

import { useTenant } from "@/lib/tenant";
import { Badge } from "@/components/ui/badge";

/**
 * Placeholder — Phase 1 ships with a single property (Spinola). Multi-property
 * switching (ARCHITECTURE.md §7) lands when Property 2 is signed.
 */
export function TenantSwitcher() {
  const { tenant } = useTenant();
  return (
    <Badge variant="outline" className="gap-1.5 px-2 py-1">
      <Building2 className="h-3 w-3" aria-hidden="true" />
      <span className="font-normal text-foreground">{tenant.name}</span>
    </Badge>
  );
}
